import { PreloadableComponent } from "@utils/lazyWithPreload";
import { useCallbackRef } from "kz-ui-sdk";
import { ReactNode, Suspense, useEffect, useLayoutEffect, useState } from "react";

export function LazyLoadComponent({
  children,
  fallback = null,
  preload,
  preloadDelay = 0,
  delay = 0,
  onLoad,
}: {
  children: React.ReactNode;
  preload?: PreloadableComponent<any>[];
  fallback?: ReactNode;
  preloadDelay?: number;
  delay?: number;
  onLoad?: () => void;
}): JSX.Element {
  const [isReady, setIsReady] = useState(false);

  const onLoadRef = useCallbackRef(onLoad);

  useEffect(() => {
    if (preload) {
      setTimeout(() => {
        preload.forEach((component) => {
          component.preload();
        });
      }, preloadDelay);
    }
  }, [preload, preloadDelay]);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (delay === 0) {
      setIsReady(true);
      return;
    } else {
      timer = setTimeout(() => {
        setIsReady(true);
      }, delay);
    }

    return () => clearTimeout(timer);
  }, [delay]);

  useLayoutEffect(() => {
    if (isReady) {
      onLoadRef?.();
    }
  }, [isReady, onLoadRef]);

  return <Suspense fallback={fallback}>{isReady ? children : null}</Suspense>;
}
